<script setup lang="ts">
    import { useI18n } from 'vue-i18n';
    import PageCard from '@/components/PageCard.vue';
    import type { Company } from '@/types';
    import CustomerDashboardStats from './CustomerDashboardStats.vue';
    import CustomerDashboardMarquee from './CustomerDashboardMarquee.vue';
    import CustomerDashboardContacts from './CustomerDashboardContacts.vue';

    const { t } = useI18n();

    const props = defineProps<{
        company: Company;
    }>();
</script>

<template>
    <PageCard class="mb-0 flex-none">
        <div class="flex flex-col items-center gap-10 overflow-hidden md:flex-row">
            <CustomerDashboardStats :company="company" />

            <CustomerDashboardMarquee :company="company" />

            <CustomerDashboardContacts :company="company" />
        </div>
    </PageCard>
</template>
